var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "menubuilder__form" },
    [
      _vm.isSending
        ? [
            _c("div", { staticClass: "menubuilder__overlay" }),
            _vm._v(" "),
            _vm._m(0),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("h3", [_vm._v("A few final details")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Before we send you your personalised menu, we need a few details."
        ),
      ]),
      _vm._v(" "),
      _c("form", { attrs: { action: "POST" } }, [
        _c("label", { attrs: { for: "fullName" } }, [
          _vm._v("\n      Full Name\n      "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.fullName,
                expression: "formData.fullName",
              },
            ],
            attrs: {
              type: "text",
              name: "fullName",
              id: "fullName",
              placeholder: "Full Name",
              required: "",
            },
            domProps: { value: _vm.formData.fullName },
            on: {
              keyup: function ($event) {
                return _vm.validateWhileTyping()
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "fullName", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _vm.formErrors.fullName
            ? _c("span", { staticClass: "menubuilder__form--error" }, [
                _vm._v(_vm._s(_vm.formErrors.fullName)),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("label", { attrs: { for: "email" } }, [
          _vm._v("\n      Email Address\n      "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.email,
                expression: "formData.email",
              },
            ],
            attrs: {
              type: "email",
              name: "email",
              id: "email",
              placeholder: "email@gmail.com",
              required: "",
            },
            domProps: { value: _vm.formData.email },
            on: {
              keyup: function ($event) {
                return _vm.validateWhileTyping()
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "email", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _vm.formErrors.email
            ? _c("span", { staticClass: "menubuilder__form--error" }, [
                _vm._v(_vm._s(_vm.formErrors.email)),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("label", { attrs: { for: "company" } }, [
          _vm._v("\n      Company Name \n      "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.companyName,
                expression: "formData.companyName",
              },
            ],
            attrs: {
              type: "text",
              name: "company",
              id: "company",
              placeholder: "Company Name",
            },
            domProps: { value: _vm.formData.companyName },
            on: {
              keyup: function ($event) {
                return _vm.validateWhileTyping()
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "companyName", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _vm.formErrors.companyName
            ? _c("span", { staticClass: "menubuilder__form--error" }, [
                _vm._v(_vm._s(_vm.formErrors.companyName)),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("label", { attrs: { for: "postcode" } }, [
          _vm._v("\n      Postcode\n      "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.postCode,
                expression: "formData.postCode",
              },
            ],
            attrs: {
              type: "text",
              name: "postcode",
              id: "postcode",
              placeholder: "Postcode",
            },
            domProps: { value: _vm.formData.postCode },
            on: {
              keyup: function ($event) {
                return _vm.validateWhileTyping()
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "postCode", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _vm.formErrors.postCode
            ? _c("span", { staticClass: "menubuilder__form--error" }, [
                _vm._v(_vm._s(_vm.formErrors.postCode)),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("label", { attrs: { for: "newsletter" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.newsletter,
                expression: "formData.newsletter",
              },
            ],
            attrs: { type: "checkbox", name: "newsletter", id: "newsletter" },
            domProps: {
              checked: Array.isArray(_vm.formData.newsletter)
                ? _vm._i(_vm.formData.newsletter, null) > -1
                : _vm.formData.newsletter,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.formData.newsletter,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(_vm.formData, "newsletter", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.formData,
                        "newsletter",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.formData, "newsletter", $$c)
                }
              },
            },
          }),
          _vm._v(
            " \n      Sign up to marketing communication with Matthew Algie?\n    "
          ),
        ]),
        _vm._v(" "),
        _c("label", { attrs: { for: "terms" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.terms,
                expression: "formData.terms",
              },
            ],
            attrs: { type: "checkbox", name: "terms", id: "terms" },
            domProps: {
              checked: Array.isArray(_vm.formData.terms)
                ? _vm._i(_vm.formData.terms, null) > -1
                : _vm.formData.terms,
            },
            on: {
              change: [
                function ($event) {
                  var $$a = _vm.formData.terms,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.formData, "terms", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.formData,
                          "terms",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.formData, "terms", $$c)
                  }
                },
                function ($event) {
                  return _vm.validateWhileTyping()
                },
              ],
            },
          }),
          _vm._v(
            "\n      By using this service, I agree with Matthew Algie's "
          ),
          _c("a", { attrs: { href: "/terms-conditions", target: "_blank" } }, [
            _vm._v("terms and conditions"),
          ]),
          _vm._v("\n      and the "),
          _c("a", { attrs: { href: "/privacy-policy" } }, [
            _vm._v("privacy policy"),
          ]),
          _vm._v(".\n      "),
          _vm.formErrors.terms
            ? _c("span", { staticClass: "menubuilder__form--error" }, [
                _vm._v(_vm._s(_vm.formErrors.terms)),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "menubuilder__formbutton" }, [
          _c(
            "button",
            {
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.$emit("preview")
                },
              },
            },
            [_vm._v("Preview")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "menubuilder__formbutton--confirm",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.submitForm()
                },
              },
            },
            [_vm._v("Confirm")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "menubuilder__messages" }, [
          _vm.errorMessage
            ? _c("p", { staticClass: "menubuilder__errormessage" }, [
                _vm._v(_vm._s(_vm.errorMessage)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.successMessage
            ? _c("p", { staticClass: "menubuilder__successmessage" }, [
                _vm._v(_vm._s(_vm.successMessage)),
              ])
            : _vm._e(),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "menubuilder__loader" }, [
      _c("div", { staticClass: "lds-ring" }, [
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
      ]),
      _vm._v(" "),
      _c("div", {}, [_vm._v("Please Wait...")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/MenuBuilder/FinalForm.vue